import React from 'react'
import {Box, Divider, Tooltip, Typography} from "@mui/material"
import { featuresList } from "Pages/AnalyzersV2/@signals"
import { dateFormatReceiver } from "@utils"
import { formatDate } from "@ui-seeker/utils"
import { dsColorNew } from "@palette"

export default function FeaturesBlock({ cellData, noResult }) {
	if (!featuresList.value.length) {
		return null
	}
	return <RenderFeaturesBlock cellData={cellData} noResult={noResult}/>
}

function RenderFeaturesBlock({ cellData, noResult }) {
	return (
		<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
			<Divider sx={{ my: 1, width: "90%", borderColor: dsColorNew.grayBorder }}/>
			<Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%" }}>
				{featuresList.value.map(feature => {
					const [field, label] = feature.split('|')
					const value = cellData[field]
					const formattedValue = dateFormatReceiver(value)
						? formatDate(value, {
							receivedFormat: dateFormatReceiver(value),
							isString: true,
						})
						: value

					return (
						<FeatureItem key={feature} label={label} value={formattedValue} noResult={noResult}/>
					)
				})}
			</Box>
		</Box>
	)
}

function FeatureItem({ label, value, noResult }) {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'flex-start',
				alignItems: 'center',
				gap: 0.5,
				width: '100%',
				minHeight: 24,
			...!noResult && {
				'&:hover': {
					'& .feature-caption': {
						fontSize: 16,
					},
					'& .feature-text': {
						fontSize: 13,
						fontWeight: 'bold',
					},
				}},
			}}
		>
			<Typography
				sx={{ fontWeight: noResult ? '' : 'bold', whiteSpace: 'nowrap' }}
				className="feature-caption"
				variant="caption"
			>
				{label}:
			</Typography>
			<Typography
				sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
				className="feature-text"
				variant="caption"
			>
				{value || 'N/A'}
			</Typography>
		</Box>
	)
}
